






















































import { Component, Prop, Vue } from 'vue-property-decorator';

import { StorageService } from '@/services/StorageService';
import { MyDetails } from '../../models/MyPlayerDetails';
import { PlayerRole } from '../../models/PlayerRole';
import { eventBus, EventBusEvents } from '../../services/EventBus';

@Component({})
export default class SideMenu extends Vue {
  @Prop({ required: true }) currentPlayer!: MyDetails | null;

  storageService: StorageService;

  playerName: string | null = null;
  playerRole: PlayerRole | null = PlayerRole.Player;
  theme: string | null;

  constructor() {
    super();
    this.storageService = new StorageService();
    this.theme = this.storageService.getTheme() || 'theme-base';
    this.playerRole = this.currentPlayer?.role || null;
  }

  get playerOrViewerIcon() {
    return this.currentPlayer?.role === PlayerRole.Viewer ? 'user-secret' : 'user';
  }

  closeSideMenu() {
    this.$emit('closeSideMenuClicked');
  }

  updateDetails(): void {
    this.$emit('updateDetailsClicked');
  }

  emitChangeThemeEvent(theme: string) {
    this.storageService.updateTheme(theme);
    eventBus.$emit(EventBusEvents.ChangeThemeEvent);
  }
}
